import { AppBar, Grid } from '@mui/material'
import Typography from '@mui/material/Typography'
import React from 'react'
import Logo from '../atoms/Logo'
import ListHeader from '../molecules/ListHeader'
import NavigationBar from '../molecules/NavigationBar'
import MobileMenu from '../molecules/MobileMenu'

const HomeHeader = () => {
	return (
		<AppBar
			position="static"
			sx={(theme) => ({
				p: theme.spacing(2.5, 4, 0),
			})}
		>
			<Grid container>
				<Grid item xs={3} md={12} lg={2}>
					<Logo />
				</Grid>
				<Grid
					item
					xs={9}
					md={12}
					lg={10}
					sx={(theme) => ({
						[theme.breakpoints.down('md')]: {
							'& .burger': {
								textAlign: 'right',
							},
							'& .MuiToolbar-root': {
								display: 'none',
							},
							justifyContent: 'flex-end',
						},
						[theme.breakpoints.up('md')]: {
							'& .burger': {
								display: 'none',
							},
						},
					})}
				>
					<NavigationBar white={false} />
					<MobileMenu white={false} />
				</Grid>
			</Grid>

			<Typography
				variant="headerTitleHome"
				sx={(theme) => ({
					[theme.breakpoints.down('md')]: {
						fontSize: 16,
						fontWeight: 900,
					},
				})}
			>
				La collecterie
			</Typography>
			<Typography
				variant="headerSubtitleHome"
				sx={(theme) => ({
					[theme.breakpoints.down('md')]: {
						fontSize: 24,
						fontWeight: 900,
					},
				})}
			>
				collecte, trie, répare, transforme, <br /> donne une seconde vie à vos objets
			</Typography>
			<Typography
				variant="headerParagrapheHome"
				sx={(theme) => ({
					[theme.breakpoints.down('md')]: {
						fontSize: 16,
					},
				})}
			>
				<strong>Débarrassez-vous</strong> de vos objets, <strong>dénichez</strong> des produits de
				seconde-main à prix solidaires, <strong>réparez et transformez</strong> votre mobilier et{' '}
				<strong>apprenez les techniques de réemploi</strong>
			</Typography>
			<ListHeader />
		</AppBar>
	)
}

export default HomeHeader
